import React from "react";
import BankActive from "../images/BankActive.svg";
import Comprehensive from "../images/Comprehensive.svg";
import Tampering from "../images/Tampering.svg";
import Handling from "../images/Handling.svg";
import Bank from "../images/Bank.svg";
import ComprehensiveActive from "../images/ComprehensiveActive.svg";
import TamperingActive from "../images/TamperingActive.svg";
import HandlingActive from "../images/HandlingActive.svg";
import "./customAnimatedCards.css";
import CustomAnimatedCards from "./CustomAnimatedCards";

const cardsData = [
  {
    id: 1,
    title: "Bank-Agnostic Parsing",
    content:
      "Works seamlessly across all banks and formats without templates or mapping.",
    activeImage: BankActive,
    inactiveImage: Bank,
  },
  {
    id: 2,
    title: "Comprehensive Analysis",
    content:
      "Deep insights and detailed analytics for better financial understanding.",
    activeImage: ComprehensiveActive,
    inactiveImage: Comprehensive,
  },
  {
    id: 3,
    title: "PDF Tampering Check",
    content: "Automated validation and verification of PDF document templates.",
    activeImage: TamperingActive,
    inactiveImage: Tampering,
  },
  {
    id: 4,
    title: "Multi-Account Handling",
    content: "Efficiently manage and process multiple accounts simultaneously.",
    activeImage: HandlingActive,
    inactiveImage: Handling,
  },
];

const StandApart = () => {
  return (
    <div className="stand-main">
      <div className="stand-apart">
        <h1 className="stand-apart-heading">
          Why <span>Befisc </span>
          Stands Apart
        </h1>
        <p className="stand-apart-text">
          BeFiSc's Bank Statement Analyser doesn’t just read statements. It
          validates authenticity, uncovers hidden risks, and delivers insights
          lenders can rely on.
        </p>
      </div>
      <div>
        <CustomAnimatedCards cards={cardsData} />
      </div>
    </div>
  );
};

export default StandApart;
